import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, map, tap, throwError } from 'rxjs';
import { ILoginByGoogle, ISSOMobileAuthLoginByGoogle } from '../login/models/login-3th.interface';
import { AuthErrorModel } from '../login/models/version-2/auth-error-version2.model';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { URI_APIs } from '@features/auth/const';
@Injectable()
export class AuthSSOMobileLoginByGoogleService implements ISSOMobileAuthLoginByGoogle {
  public httpClient = inject(HttpClient);
  conf = inject(CoreAuthConfigService);

  constructor() { }

  googleAuth(clientId: string, accessToken: string, code_challenge: string, redirect_uri: string) {
    const requestBody = {
      access_token: accessToken,
      code_challenge: code_challenge,
      redirect_uri: redirect_uri,
      clientId: clientId
    };

    return this.httpClient
      .post(this.conf.buildURL(URI_APIs.SSO_MOBILE_LOGIN_GMAIL), requestBody)
      .pipe(
        catchError((err) => {
          return throwError(() => AuthErrorModel.handle(err));
        }),
      );
  }
}
